
import * as directProviderRuntime$kxmJxjkNVe from '/builds/escapadarural/rurality-nuxt/providers/direct-provider.ts'
import * as ipxRuntime$44cddJpJwa from '/builds/escapadarural/rurality-nuxt/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "dev.media.er2.co",
    "media.er2.co",
    "static.er2.co",
    "loremflickr.com",
    "s3-static.escapadarural.com",
    "www.escapadarural.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['directProvider']: { provider: directProviderRuntime$kxmJxjkNVe, defaults: {"baseURL":""} },
  ['ipx']: { provider: ipxRuntime$44cddJpJwa, defaults: {} }
}
        